/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TariffInfoDto } from './tariff-info-dto';
import {
    TariffInfoDtoFromJSON,
    TariffInfoDtoFromJSONTyped,
    TariffInfoDtoToJSON,
    TariffInfoDtoToJSONTyped,
} from './tariff-info-dto';

/**
 * 
 * @export
 * @interface PreorderRoomInfoDto
 */
export interface PreorderRoomInfoDto {
    /**
     * Название номера
     * @type {string}
     * @memberof PreorderRoomInfoDto
     */
    name: string;
    /**
     * 
     * @type {TariffInfoDto}
     * @memberof PreorderRoomInfoDto
     */
    tariff: TariffInfoDto;
    /**
     * Контрольная сумма
     * @type {string}
     * @memberof PreorderRoomInfoDto
     */
    checksum: string;
}

/**
 * Check if a given object implements the PreorderRoomInfoDto interface.
 */
export function instanceOfPreorderRoomInfoDto(value: object): value is PreorderRoomInfoDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tariff' in value) || value['tariff'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    return true;
}

export function PreorderRoomInfoDtoFromJSON(json: any): PreorderRoomInfoDto {
    return PreorderRoomInfoDtoFromJSONTyped(json, false);
}

export function PreorderRoomInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreorderRoomInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'tariff': TariffInfoDtoFromJSON(json['tariff']),
        'checksum': json['checksum'],
    };
}

  export function PreorderRoomInfoDtoToJSON(json: any): PreorderRoomInfoDto {
      return PreorderRoomInfoDtoToJSONTyped(json, false);
  }

  export function PreorderRoomInfoDtoToJSONTyped(value?: PreorderRoomInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'tariff': TariffInfoDtoToJSON(value['tariff']),
        'checksum': value['checksum'],
    };
}

